import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PlanGate({ isAllowed, featureName, currentPlan, restaurantId, children }) {
    const navigate = useNavigate();

    if (isAllowed) {
        return <>{children}</>;
    }

    return (
        <div className="relative group overflow-hidden rounded-2xl border border-slate-200 bg-slate-50">
            <div className="opacity-20 pointer-events-none filter blur-[2px] select-none h-[250px] overflow-hidden">
                {children}
            </div>
            
            <div className="absolute inset-0 flex flex-col items-center justify-center p-6 bg-gradient-to-t from-slate-100/90 via-slate-100/50 to-transparent backdrop-blur-[1px]">
                <div className="w-12 h-12 bg-charcoal rounded-full flex items-center justify-center shadow-lg mb-3">
                    <span className="material-symbols-outlined text-primary text-xl">lock</span>
                </div>
                <h3 className="text-charcoal font-black text-xl mb-1">{featureName}</h3>
                <p className="text-slate-500 text-sm text-center font-medium max-w-xs mb-5">
                    Upgrade your plan to unlock {featureName.toLowerCase()} and grow your business.
                </p>
                <button
                    onClick={() => navigate('/subscription')}
                    className="bg-primary text-charcoal font-bold px-6 py-2.5 rounded-xl text-sm shadow-sm hover:bg-[#F0C900] active:scale-95 transition-colors flex items-center gap-2"
                >
                    <span className="material-symbols-outlined text-base">upgrade</span>
                    Upgrade Plan
                </button>
            </div>
        </div>
    );
}
